import { render, staticRenderFns } from "./NewAddressForm.vue?vue&type=template&id=b8ba1644&scoped=true"
import script from "./NewAddressForm.vue?vue&type=script&lang=js"
export * from "./NewAddressForm.vue?vue&type=script&lang=js"
import style0 from "./NewAddressForm.vue?vue&type=style&index=0&id=b8ba1644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ba1644",
  null
  
)

export default component.exports